<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormUser" role="form" method="post" autocomplete="off" onSubmit="return false">	

					<!--<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
							<div class="avatar-upload">
                                <div class="avatar-edit">
                                    <input type="file" @change="$uploadImagePreview($event,ValidElement, Array('Img','imagePreview'))" id="file" name="file" ref="fileImg" accept=".png, .jpg, .jpeg">
                                    <label for="file"></label>
                                </div>
                                <div class="avatar-preview">
                                    <div id="imagePreview" :style="'background-image: url('+Img+')'" :src="Img">
                                    </div>
                                </div>
                            </div>
						</div>
					</div> -->

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objUsuario.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Apellido">Apellido</label>
							<input type="text" v-model="objUsuario.Apellido" class="form-control" id="Apellido" placeholder="Ingresar Apellido" />
							<CValidation v-if="this.errorvalidacion.Apellido" :Mensaje="'*'+errorvalidacion.Apellido[0]"/>
						</div>
					</div>
					
				
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="username">Usuario</label>
							<input type="text" v-model="objUsuario.username" class="form-control" id="username" placeholder="Ingresar username" :disabled="parseInt(objUsuario.IdUsuario) > 0" />
							<CValidation v-if="this.errorvalidacion.username" :Mensaje="'*'+errorvalidacion.username[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 pt-4">
							<div class="form-check form-switch">
								<input v-model="objUsuario.Estatus" class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault">
								<label class="form-check-label" for="flexSwitchCheckDefault">Estatus usuario: <template v-if="objUsuario.Estatus">Activo</template> <template v-else>Inactivo</template> </label>
							</div>
						</div>
						<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 pt-4">
							<div class="form-check form-switch">
								<input v-model="objUsuario.VerCotizacion" class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault2">
								<label class="form-check-label" for="flexSwitchCheckDefault2">Ver costos de cotización</label>
							</div>
						</div>
					</div>
					
					
					<div v-if="parseInt(objUsuario.IdUsuario) == 0" class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="password">Contraseña</label>
							<input type="text" v-model="objUsuario.password" class="form-control" id="password" placeholder="Ingresar password" />
							<CValidation v-if="this.errorvalidacion.password" :Mensaje="'*'+errorvalidacion.password[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="password_confirmation">Confirmar Contraseña</label>
							<input type="text" v-model="objUsuario.password_confirmation" class="form-control" id="password_confirmation" placeholder="Ingresar password" />
							<CValidation v-if="this.errorvalidacion.password_confirmation" :Mensaje="'*'+errorvalidacion.password_confirmation[0]"/>
						</div>
					</div>


					<div v-if="parseInt(objUsuario.IdUsuario) == 0" class="form-group row">
						

						<div v-if="origen != 'Clientes'" class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="IdPerfil">Perfil</label>
							<select v-model="objUsuario.IdPerfil" class="form-control-search form-select" id="IdPerfil">
								<option value="0">Seleccione una opción</option>
								<option v-for="(item, index) in ListaCombo1" :key="index" :value="item.IdPerfil">{{item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdPerfil" :Mensaje="'*'+errorvalidacion.IdPerfil[0]"/>
						</div>

						<div v-if="origen == 'Clientes'" class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 pt-4">
							<div class="form-check form-switch">
								<input v-model="objUsuario.VerPagos" class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault">
								<label class="form-check-label" for="flexSwitchCheckDefault">Ver Pagos</label>
							</div>
						</div>
						<div v-if="origen == 'Clientes'" class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 pt-4">
							<div class="form-check form-switch">
								<input v-model="objUsuario.VerFacturas" class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault2">
								<label class="form-check-label" for="flexSwitchCheckDefault2">Ver Facturas</label>
							</div>
						</div>

						
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormUsuario',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objUsuario: {
				IdUsuario: 0,
				IdPerfil: 0,
				IdCliente: 0,
				Nombre: '',
				Apellido: '',
				NombreCompleto: '',
				username: '',
				password: '',
				Correo: '',
				Confirmado: 0,
				Tipo: '',
				VerCotizacion: false,
				VerPagos: false,
        		VerFacturas: false,
				Estatus: false,
				
            },
			ObjCliente: {
				IdCliente: 0
			},

            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			ListaCombo1: [],
			origen:'',
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion 			= [];
			this.poBtnSave.Toast 			= 0; 
			this.poBtnSave.DisableBtn 		= true;
			this.objUsuario.VerCotizacion 	= (this.objUsuario.VerCotizacion) ? 'SI' : 'NO';
			this.objUsuario.Estatus 		= (this.objUsuario.Estatus) ? 'A' : 'B';
			this.objUsuario.VerPagos 		= (this.objUsuario.VerPagos) ? 'SI' : 'NO';
			this.objUsuario.VerFacturas 	= (this.objUsuario.VerFacturas) ? 'SI' : 'NO';
			this.objUsuario.Origen			= this.origen;
			this.objUsuario.IdCliente		= this.ObjCliente.IdCliente;

			await this.$http.post(
				'users',this.objUsuario
			).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
			
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
			this.objUsuario.VerCotizacion 	=  (this.objUsuario.VerCotizacion == 'SI' ) ? true : false;
			this.objUsuario.Estatus 		=  (this.objUsuario.Estatus == 'A' ) ? true : false;
			this.objUsuario.VerPagos 		=  (this.objUsuario.VerPagos == 'SI' ) ? true : false;
			this.objUsuario.VerFacturas 	=  (this.objUsuario.VerFacturas == 'SI' ) ? true : false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "users/"+this.objUsuario.IdUsuario
            ).then((res) => {
                this.objUsuario = res.data.data;

				this.objUsuario.VerCotizacion 	=  (this.objUsuario.VerCotizacion == 'SI' ) ? true : false;
				this.objUsuario.Estatus 		=  (this.objUsuario.Estatus == 'A' ) ? true : false;
				this.objUsuario.VerPagos 		=  (this.objUsuario.VerPagos == 'SI' ) ? true : false;
				this.objUsuario.VerFacturas 	=  (this.objUsuario.VerFacturas == 'SI' ) ? true : false;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objUsuario.Fecha.replace(/-/g,'\/');
                this.objUsuario.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objUsuario = {
				IdUsuario: 0,
				IdPerfil: 0,
				IdCliente: 0,
				Nombre: '',
				Apellido: '',
				NombreCompleto: '',
				username: '',
				password: '',
				Correo: '',
				Confirmado: 0,
				Tipo: '',
				VerCotizacion: false,
				VerPagos: false,
        		VerFacturas: false,
				Estatus: '',
				
            }
            this.errorvalidacion = [];
        },

		getListPerfiles()
		{
			this.$http.get("perfiles", {
				params:{
					simple: 1,
				}
			}).then((res) => {
				this.ListaCombo1 = res.data.data;
			});
		},
    },
	computed:{
		/*checkEstatus(){
            if(this.objUsuario.Estatus) {
                this.pProducto.ProgramarFechaPub = false;
                this.pProducto.FechaPublicacion = new Date();//this.getNowDate();
            }
        },*/
	},
    created() {

		if(sessionStorage.getItem('origen') != undefined && sessionStorage.getItem('origen') != null ) {
			this.origen = sessionStorage.getItem('origen');
		}

		if(sessionStorage.getItem('objGeneral') != undefined && sessionStorage.getItem('objGeneral') != null ) {
			this.ObjCliente = JSON.parse(sessionStorage.getItem('objGeneral'));
		}else {
			this.ObjCliente.IdCliente = 0;
		}

		this.poBtnSave.Toast = 0;
		this.getListPerfiles();

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();

			//let ObjIdCliente = JSON.parse(sessionStorage.getItem('objIdCliente'));
			//this.objUsuario.IdCliente = ObjIdCliente.IdCliente;
                
            if (Id!='') 
            {
                this.objUsuario.IdUsuario = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
